import { NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { FcOutlinedInputModule } from '@core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { TreeViewModule } from '@core/components/fc-tree-view/fc-tree-view.module';
import { VideoInfoModalModule } from '@core/components/video-info-modal/video-info-modal.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TabLinksService } from '../../../dialog-create-maintenance/tabs/links/tab-links.service';
import { TabLinksComponent } from './tab-links.component';

@NgModule({
  declarations: [
    TabLinksComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatIconModule,
    MatButtonModule,
    FcOutlinedInputModule,
    TreeViewModule,
    VideoInfoModalModule
  ],
  providers: [
    TabLinksService
  ],
  exports: [
    TabLinksComponent
  ]
})
export class TabLinksModule { }
